import { ActivatedRouteSnapshot, Data, Router, UrlTree } from '@angular/router';
import { inject } from '@angular/core';
import {
  Section,
  SettingsBoolean,
  SystemSettingKey,
  SystemSettingsService
} from '@core/services/settings/system-settings.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AccessDeniedPath } from '@core/constants';
export type SystemSettingData = {
  systemSetting?: SystemSettingKey;
};

export interface SystemSettingRouteGuard extends Data {
  data?: SystemSettingData;
}

/**
 * If settings is enabled, allows activation. Otherwise, routes user to the access denied page.
 * @param route
 */
export const systemSettingGuard: (
  route: ActivatedRouteSnapshot
) => Observable<boolean | UrlTree> = (route) => {
  const routeData: SystemSettingData = route.data as SystemSettingData;
  const systemSetting: SystemSettingKey = routeData.systemSetting;
  const _router: Router = inject(Router);
  const _systemSettingsService: SystemSettingsService = inject(
    SystemSettingsService
  );
  if (!systemSetting)
    console.warn(
      'No system setting found, please configure your route with a system setting in the data configuration.'
    );

  // Reads the shared, cached all-sections fetch, so the setting may live in any section.
  return _systemSettingsService.settings.pipe(
    map((settings) => {
      const setting = settings.find((s) => s.field === systemSetting);
      const isEnabled =
        !!setting &&
        _systemSettingsService.getSystemSettingsBoolean(
          setting as Section<SettingsBoolean>
        );
      if (!isEnabled) return _router.parseUrl(`/${AccessDeniedPath}`);

      return true;
    })
  );
};
